/**
 * @file index.tsx
 *
 * @fileoverview Generic error to be displayed when an error boundary is triggerd in the main App.
 */
import Head from 'next/head';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { getCommonTranslations } from '~/jobiqo/utils/intl';
import { LinkButton } from '~/vcl/atoms/01-forms/01-button/02-link-button';
import { CenterBox } from '~/vcl/atoms/06-layout/01-alignment/02-center-box';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { ErrorGenericIcon } from '~/vcl/icons/ErrorGeneric';
import { HomeIcon } from '~/vcl/icons/Home';
import { EmptyElement } from '~/vcl/molecules/02-empty';
import Link from '~/jobiqo/components/Link';

export const AppGenericError = () => {
  const { ERROR_BACK_TO_HOME } = getCommonTranslations();
  return (
    <>
      <Head>
        <meta name="owner" content="jd-generic-error" key="jd-owner" />
      </Head>
      <CenterBox>
        <EmptyElement
          icon={
            <ErrorGenericIcon
              color="primary"
              width="300"
              height="300"
              title="Error"
            />
          }
        >
          <p>
            <FormattedMessage
              id="app_generic_error"
              defaultMessage="There was an unexpected error on the website. We are monitoring the error so that a fix can be made and it doesn't happen again.
              In the meanwhile try to reload the page or {contactLink} us if the error persists."
              values={{
                contactLink: (
                  <Link href="/contact">
                    <FormattedMessage
                      id="error_contact_label"
                      defaultMessage="Contact"
                    />
                  </Link>
                ),
              }}
            />
          </p>
          <Spacing size="medium" />
          <LinkButton href="/" buttonStyle="primary">
            <HomeIcon title="Home" />
            <span>{ERROR_BACK_TO_HOME}</span>
          </LinkButton>
        </EmptyElement>
      </CenterBox>
    </>
  );
};
export default AppGenericError;
